// extracted by mini-css-extract-plugin
export default {"authContainer":"style_authContainer__1pliS","header":"style_header__1baLg","userContainer":"style_userContainer__wYcrN","contentContainer":"style_contentContainer__zq1DE"};